import React, { useEffect, useState } from 'react';
import { Avatar, List, ListItem, ListItemAvatar, ListItemText, Pagination, Paper, Stack, Typography } from '@mui/material';
import { fetchCompetitionActivities } from '../../services/Competition';
import { getImageUrlAdminToken } from '../../utills/ImagesUtilsAdmin';
import { timeAgo } from '../../../utils/TimeFormat';
import { useNavigate } from 'react-router-dom';

const Activities = ({ competitionId }) => {
    const navigate = useNavigate();
    const [activities, setActivities] = useState([]);
    const [pagination, setPagination] = useState({
        current_page: 1,
        total_pages: 1,
    });

    useEffect(() => {
        const fetchActivities = async () => {
            try {
                const data = await fetchCompetitionActivities(competitionId, { page: pagination.current_page });
                console.log("Fetched activities:", data);
                if (data.status) {
                    setActivities(data.activities || []);
                    setPagination({
                        current_page: data.pagination.current_page,
                        total_pages: data.pagination.last_page,
                    });
                }
            } catch (error) {
                console.error("Error fetching activities:", error);
            }
        };

        if (competitionId) {
            fetchActivities();
        }
    }, [competitionId, pagination.current_page]);

    const handlePageChange = (event, value) => {
        setPagination((prev) => ({
            ...prev,
            current_page: value,
        }));
    };

    return (
        <React.Fragment>
            <Paper elevation={0} sx={{ p: 2, mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                    All Activities
                </Typography>
                <List>
                    {activities.map((activity) => (
                        <ListItem key={activity.id} alignItems="flex-start">
                            <ListItemAvatar onClick={() => navigate(`/users/${activity.user_id}`)} sx={{ cursor: 'pointer' }}>
                                <Avatar src={getImageUrlAdminToken(activity.thumbnail_pic)} alt={activity.user_name} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={
                                    <React.Fragment>
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            sx={{ color: 'text.primary', display: 'inline' }}
                                        >
                                            <strong>{activity.user_name}</strong> has been rated <strong>{activity.rating}</strong>★ on <strong>{activity.entity_name}</strong>
                                        </Typography>
                                        {" — "}{activity.review || "No review provided"}
                                    </React.Fragment>
                                }
                                secondary={timeAgo(activity.reviewed_at)}
                                slotProps={{ secondary: { fontSize: '0.8rem', color: 'text.secondary' } }}
                            />
                        </ListItem>
                    ))}
                </List>
                {activities.length === 0 && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                        No activities found.
                    </Typography>
                )}
            </Paper>
            {pagination.total_pages > 1 && (
                <Stack alignItems="center" sx={{ mt: 2 }}>
                    <Pagination
                        count={pagination.total_pages}
                        page={pagination.current_page}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded"
                        color="primary"
                    />
                </Stack>
            )}
        </React.Fragment>
    );
};

export default Activities;